export const FETCH_ACCEPT_INVITE_REQUEST = 'FETCH_ACCEPT_INVITE_REQUEST';
export const FETCH_ACCEPT_INVITE_SUCCESS = 'FETCH_ACCEPT_INVITE_SUCCESS';
export const FETCH_ACCEPT_INVITE_FAILURE = 'FETCH_ACCEPT_INVITE_FAILURE';

export const FETCH_DECLINE_INVITE_REQUEST = 'FETCH_DECLINE_INVITE_REQUEST';
export const FETCH_DECLINE_INVITE_SUCCESS = 'FETCH_DECLINE_INVITE_SUCCESS';
export const FETCH_DECLINE_INVITE_FAILURE = 'FETCH_DECLINE_INVITE_FAILURE';

export const FETCH_ACCEPT_JOIN_REQUEST = 'FETCH_ACCEPT_JOIN_REQUEST';
export const FETCH_ACCEPT_JOIN_SUCCESS = 'FETCH_ACCEPT_JOIN_SUCCESS';
export const FETCH_ACCEPT_JOIN_FAILURE = 'FETCH_ACCEPT_JOIN_FAILURE';
export const RESET_ACCEPT_JOIN_STATE = 'RESET_ACCEPT_JOIN_STATE';

export const FETCH_FORFEIT_REQUEST = 'FETCH_FORFEIT_REQUEST';
export const FETCH_FORFEIT_SUCCESS = 'FETCH_FORFEIT_SUCCESS';
export const FETCH_FORFEIT_FAILURE = 'FETCH_FORFEIT_FAILURE';

export const FETCH_MATCH_PERCENTAGE_REQUEST = 'FETCH_MATCH_PERCENTAGE_REQUEST';
export const FETCH_MATCH_PERCENTAGE_SUCCESS = 'FETCH_MATCH_PERCENTAGE_SUCCESS';
export const FETCH_MATCH_PERCENTAGE_FAILURE = 'FETCH_MATCH_PERCENTAGE_FAILURE';

export const FETCH_JOIN_MATCH_REQUEST = 'FETCH_JOIN_MATCH_REQUEST';
export const FETCH_JOIN_MATCH_SUCCESS = 'FETCH_JOIN_MATCH_SUCCESS';
export const FETCH_JOIN_MATCH_FAILURE = 'FETCH_JOIN_MATCH_FAILURE';

export const FETCH_REJECT_JOIN_REQUEST = 'FETCH_REJECT_JOIN_REQUEST';
export const FETCH_REJECT_JOIN_SUCCESS = 'FETCH_REJECT_JOIN_SUCCESS';
export const FETCH_REJECT_JOIN_FAILURE = 'FETCH_REJECT_JOIN_FAILURE';
export const RESET_REJECT_JOIN_STATE = 'RESET_REJECT_JOIN_STATE';

export const FETCH_WITHDRAW_REQUEST = 'FETCH_WITHDRAW_REQUEST';
export const FETCH_WITHDRAW_SUCCESS = 'FETCH_WITHDRAW_SUCCESS';
export const FETCH_WITHDRAW_FAILURE = 'FETCH_WITHDRAW_FAILURE';
export const RESET_WITHDRAW_STATES = 'RESET_WITHDRAW_STATES';

export const FETCH_GET_OPEN_MATCH_REQUEST = 'FETCH_GET_OPEN_MATCH_REQUEST';
export const FETCH_GET_OPEN_MATCH_SUCCESS = 'FETCH_GET_OPEN_MATCH_SUCCESS';
export const FETCH_GET_OPEN_MATCH_FAILURE = 'FETCH_GET_OPEN_MATCH_FAILURE';
export const SET_WITHDRAW_MATCH_ID = 'SET_WITHDRAW_MATCH_ID';

export const FETCH_ACTIVE_TOURNAMENT_REQUEST = 'FETCH_ACTIVE_TOURNAMENT_REQUEST';
export const FETCH_ACTIVE_TOURNAMENT_SUCCESS = 'FETCH_ACTIVE_TOURNAMENT_SUCCESS';
export const FETCH_ACTIVE_TOURNAMENT_FAILURE = 'FETCH_ACTIVE_TOURNAMENT_FAILURE';

export const FETCH_GET_PENDING_MATCH_REQUEST = 'FETCH_GET_PENDING_MATCH_REQUEST';
export const FETCH_GET_PENDING_MATCH_SUCCESS = 'FETCH_GET_PENDING_MATCH_SUCCESS';
export const FETCH_GET_PENDING_MATCH_FAILURE = 'FETCH_GET_PENDING_MATCH_FAILURE';

export const FETCH_GET_MATCH_HISTORY_REQUEST = 'FETCH_GET_MATCH_HISTORY_REQUEST';
export const FETCH_GET_MATCH_HISTORY_SUCCESS = 'FETCH_GET_MATCH_HISTORY_SUCCESS';
export const FETCH_GET_MATCH_HISTORY_FAILURE = 'FETCH_GET_MATCH_HISTORY_FAILURE';

export const FETCH_GET_MATCH_DETAILS_REQUEST = 'FETCH_GET_MATCH_DETAILS_REQUEST';
export const FETCH_GET_MATCH_DETAILS_SUCCESS = 'FETCH_GET_MATCH_DETAILS_SUCCESS';
export const FETCH_GET_MATCH_DETAILS_FAILURE = 'FETCH_GET_MATCH_DETAILS_FAILURE';

export const FETCH_PLAY_MATCH_REQUEST = 'FETCH_PLAY_MATCH_REQUEST';
export const FETCH_PLAY_MATCH_SUCCESS = 'FETCH_PLAY_MATCH_SUCCESS';
export const FETCH_PLAY_MATCH_FAILURE = 'FETCH_PLAY_MATCH_FAILURE';
export const RESET_PLAY_MATCH_STATES = 'RESET_PLAY_MATCH_STATES';

export const FETCH_MATCH_HISTORY_DETAIL_REQUEST = 'FETCH_MATCH_HISTORY_DETAIL_REQUEST';
export const FETCH_MATCH_HISTORY_DETAIL_SUCCESS = 'FETCH_MATCH_HISTORY_DETAIL_SUCCESS';
export const FETCH_MATCH_HISTORY_DETAIL_FAILURE = 'FETCH_MATCH_HISTORY_DETAIL_FAILURE';

export const FETCH_MATCH_USERNAME_REQUEST = 'FETCH_MATCH_USERNAME_REQUEST';
export const FETCH_MATCH_USERNAME_SUCCESS = 'FETCH_MATCH_USERNAME_SUCCESS';
export const FETCH_MATCH_USERNAME_FAILURE = 'FETCH_MATCH_USERNAME_FAILURE';
export const RESET_SPECTATOR_USER_LIST_STATE = 'RESET_SPECTATOR_USER_LIST_STATE';
